import { AUTH_RESET_2FA_ACCEPT, AUTH_RESET_2FA_ACCEPT_FAILED, AUTH_RESET_2FA_ACCEPT_SUCCESS } from './types';
import { apiAction } from '../../api/actions';

export function reset2FAAccept(token, email, password, onSuccess, onFailure) {
  return apiAction({
    resource: '/su/auth/reset-2fa-accept',
    method: 'POST',
    data: {
      token,
      email,
      password
    },
    onSuccess: (data) => onSuccessReset2FAAccept(data, onSuccess),
    onFailure: (error) => onFailedReset2FAAccept(error, onFailure),
    carry: {
      label: AUTH_RESET_2FA_ACCEPT
    },
  });
}

function onSuccessReset2FAAccept(data, onSuccess) {
  onSuccess();
  return {
    type: AUTH_RESET_2FA_ACCEPT_SUCCESS,
    payload: data
  };
}

function onFailedReset2FAAccept(error, onFailure) {
  // Determine error translation key based on status code
  let translationKey = 'reset-2fa-accept.error-generic';

  const statusCode = error?.response?.status;

  if (statusCode === 400) {
    translationKey = 'reset-2fa-accept.error-invalid-token';
  } else if (statusCode === 401) {
    translationKey = 'reset-2fa-accept.error-invalid-password';
  } else if (statusCode === 410) {
    translationKey = 'reset-2fa-accept.error-expired-token';
  }

  onFailure(translationKey);
  return {
    type: AUTH_RESET_2FA_ACCEPT_FAILED,
    payload: {
      error
    }
  };
}
